(() => {
  'use strict';
  const phone = '528110540443';
  const labels = new WeakMap();
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  const normalized = value => clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const label = el => {
    if (!labels.has(el)) labels.set(el, clean(el.getAttribute('aria-label') || el.textContent || el.querySelector('img')?.alt));
    return labels.get(el);
  };
  const contactIntent = /cotiz|asesor|solicitar (?:informacion|evaluacion|propuesta)|(?:pedir|quiero|necesito) (?:informacion|ayuda)|contactar|contactanos|hablar con|platicar|cuentanos tu proyecto|consultar personalizacion|whatsapp/;
  const isContact = el => {
    if (el.closest('.pm-help,form,nav,[role="navigation"],cart-drawer,cart-notification') || el.hasAttribute('download') || el.hasAttribute('disabled')) return false;
    const href = el.getAttribute('href') || '';
    if (/^(?:tel:|mailto:)/i.test(href) || /\/(?:cart|checkout|account)(?:[/?#]|$)/i.test(href)) return false;
    if (el.tagName === 'BUTTON' && (el.type === 'submit' || el.getAttribute('type') === 'submit')) return false;
    if (el.dataset.pmWhatsappQuote === 'true') return true;
    let target;
    try { target = new URL(href, location.href); } catch (_) { return false; }
    const whatsapp = /^(?:wa\.me|(?:api|web)\.whatsapp\.com)$/.test(target.hostname);
    const localContact = target.origin === location.origin && /\/pages\/contacto?\/?$/i.test(target.pathname);
    return whatsapp || contactIntent.test(normalized(label(el))) || (localContact && !/^contacto?$/i.test(label(el)));
  };
  const heading = root => { const el = root?.querySelector('h1,h2,h3,h4,[role="heading"]'); return clean(el?.innerText || el?.textContent); };
  const sectionTitle = el => {
    if (!el.closest('main')) return label(el);
    let root = el.parentElement;
    while (root && root !== document.body) {
      if (root.matches('main,header,footer')) break;
      const title = heading(root);
      if (title) return title;
      if (root.matches('.ppm-guidance')) return clean(root.querySelector('strong')?.textContent);
      if (root.matches('section,article,aside,[role="region"]')) return clean(root.getAttribute('aria-label')) || label(el);
      root = root.parentElement;
    }
    return label(el);
  };
  const pageTitle = () => location.pathname === '/' ? 'Inicio' : /\/pages\/nosotros\/?$/.test(location.pathname) ? 'Nosotros' : clean(document.querySelector('main h1')?.textContent || document.title.split('|')[0]);
  const url = el => {
    const card = el.closest('[data-pm-whatsapp-product],[data-product-model],[data-license-card],.pmnl-card,.ppm-product,.card-wrapper,.product-card');
    const product = clean(card?.dataset.pmWhatsappProduct || card?.dataset.productModel || card?.dataset.search || heading(card));
    const variant = clean(card?.querySelector('[data-pm-wa-variant]')?.value || card?.querySelector('[data-selected-variant]')?.textContent || card?.querySelector('[data-variant][aria-pressed="true"]')?.dataset.variant);
    const page = pageTitle();
    const section = sectionTitle(el);
    const action = normalized(label(el));
    const request = /soporte/.test(action) ? 'solicitar soporte' : /cotiz/.test(action) ? 'solicitar una cotización' : /evaluacion/.test(action) ? 'solicitar una evaluación' : /informacion/.test(action) ? 'recibir información' : 'recibir asesoría';
    const context = [...new Set([page, section].filter(Boolean))].join(' — ');
    let message = 'Hola, vengo de la sección «' + context + '» de Pepe Monedas. Me gustaría ' + request;
    message += product ? ' sobre ' + product + (variant && variant !== 'Default Title' ? ', variante ' + variant : '') + '.' : '.';
    const source = new URL(card?.querySelector('h3 a[href*="/products/"]')?.href || location.href);
    source.search = '';
    source.hash = '';
    const anchor = el.closest('article[id],section[id]');
    if (anchor && !anchor.id.startsWith('shopify-section-') && source.pathname === location.pathname) source.hash = anchor.id;
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message + ' ' + source.href);
  };
  const updateLink = el => {
    // Keep the current number on every existing WhatsApp link, including help/navigation.
    if (el.tagName === 'A') {
      try {
        const current = new URL(el.getAttribute('href') || '', location.href);
        if (/^(?:wa\.me|(?:api|web)\.whatsapp\.com)$/.test(current.hostname)) {
          const message = current.searchParams.get('text');
          const canonical = 'https://wa.me/' + phone + (message ? '?text=' + encodeURIComponent(message) : '');
          if (el.getAttribute('href') !== canonical) el.setAttribute('href', canonical);
          el.target = '_blank';
          el.rel = 'noopener';
          return;
        }
      } catch (_) { /* Non-URL controls retain native behavior. */ }
    }
    if (!isContact(el)) return;
    el.dataset.pmWhatsappQuote = 'true';
    if (el.tagName === 'A') {
      const href = url(el);
      if (el.getAttribute('href') !== href) el.setAttribute('href', href);
      el.target = '_blank';
      el.rel = 'noopener';
    }
  };
  const update = () => document.querySelectorAll('a,button').forEach(updateLink);
  // Recompute at activation so variant changes are reflected, preserving native link behavior.
  document.addEventListener('click', event => {
    const el = event.target.closest?.('a,button');
    if (!el || !isContact(el)) return;
    updateLink(el);
    if (el.tagName === 'BUTTON') {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.open(url(el), '_blank', 'noopener');
    }
  }, true);
  document.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();


